import React from 'react'

import { ReceivingAsnSummary } from '../fixtures'
import { AsnSummaryCard, AsnSummaryDetails, AsnSummaryHeader } from '../styles'

interface AsnSummaryProps {
  asn: ReceivingAsnSummary
}

export const AsnSummary = ({ asn }: AsnSummaryProps) => (
  <AsnSummaryCard>
    <AsnSummaryHeader>
      <strong>{asn.company}</strong>
    </AsnSummaryHeader>
    <AsnSummaryDetails>
      <dt>Sender</dt>
      <dd>{asn.sender}</dd>
      <dt>Expected date</dt>
      <dd>{asn.expectedDate}</dd>
      <dt>Shipment reference</dt>
      <dd>{asn.shipmentReference}</dd>
      <dt>Lines</dt>
      <dd>{asn.lineCount}</dd>
      <dt>Expected (eaches)</dt>
      <dd>{asn.expectedUnits.toLocaleString('en-US')}</dd>
    </AsnSummaryDetails>
  </AsnSummaryCard>
)
